import { editHyperlink } from './getEditLinkContextMenuItem.locstring.json';
import { ReplaceLinkHandler } from '../../components/LinkContextMenu';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import { logUsage } from 'owa-analytics';
import getLinkText from 'owa-compose-link/lib/utils/getLinkText';
import { DialogResponse } from 'owa-confirm-dialog';
import { InsertLinkProperties, lazyDisplayInsertLinkDialog } from 'owa-editor-ribbonplugin';
import loc from 'owa-localize';
import { isNullOrWhiteSpace } from 'owa-string-utils';

export function getEditLinkContextMenuItem(
    anchorElement: HTMLAnchorElement,
    editUrlHandler: ReplaceLinkHandler
): IContextualMenuItem {
    // preload lazyDisplayInsertLinkDialog
    lazyDisplayInsertLinkDialog.import();
    return {
        name: loc(editHyperlink),
        key: 'EditLink',
        onClick: () => {
            logUsage('AttachmentLinkViewEditLink');
            editLink(anchorElement, editUrlHandler);
        },
    };
}

async function editLink(anchorElement: HTMLAnchorElement, editUrlHandler: ReplaceLinkHandler) {
    const anchorElementText = getLinkText(anchorElement);
    const insertLink: InsertLinkProperties = {
        LinkUrl: anchorElement.href,
        DisplayText: anchorElementText,
        HasChanged: false,
    };
    const displayInsertLinkDialog = await lazyDisplayInsertLinkDialog.import();
    if (
        (await displayInsertLinkDialog(insertLink)) === DialogResponse.ok &&
        insertLink.HasChanged
    ) {
        // If the url is unchanged, and the user removed the display text we leave the link as is.
        if (
            insertLink.LinkUrl === anchorElement.href &&
            isNullOrWhiteSpace(insertLink.DisplayText)
        ) {
            return;
        }
        editUrlHandler(
            insertLink.LinkUrl,
            insertLink.DisplayText.length > 0 ? insertLink.DisplayText : null
        );
    }
}
